export default {
  it: {
    slides: [
      {
        h4: 'Analisi<br>preliminare',
        ul: [
          'scenari e trend', 'media information', 'analisi del contesto commerciale',
        ],
      },
      {
        h4: 'Piattaforma,<br>strategica',
        ul: [
          'visione del mercato', 'analisi della concorrenza', 'analisi del sentiment', 'fruizione dei mezzi',
        ],
      },
      {
        h4: 'Pianificazione<br>dei touchpoint',
        ul: [
          'selezione dei canali', 'selezione dei momenti', 'sviluppo della strategia',
        ],
      },
      {
        h4: 'Media buying<br>& ottimizzazione',
        ul: [
          'strategia d’acquisto', 'negoziazione', 'ottimizzazione', 'misurazione',
        ],
      },
      {
        h4: 'Ritorno<br>sull’investimento',
        ul: [
          'analisi quantitative', 'analisi qualitative', 'analisi econometriche',
        ],
      },
    ],
  },
  en: {
    slides: [
      {
        h4: 'Preliminary<br>analysis',
        ul: [
          'trends and scenarios', 'media information', 'business environment analysis',
        ],
      },
      {
        h4: 'Strategic<br>platform',
        ul: [
          'market vision', 'competitor analysis', 'sentiment analysis', 'media fruition',
        ],
      },
      {
        h4: 'Touchpoint<br>planning',
        ul: [
          'channel selection', 'moment selection', 'strategy development',
        ],
      },
      {
        h4: 'Media buying<br>& optimization',
        ul: [
          'purchase strategy', 'negotiation', 'optimization', 'measurement',
        ],
      },
      {
        h4: 'Return on<br>investment',
        ul: [
          'quantitative analysis', 'qualitative analysis', 'econometric analysis',
        ],
      },
    ],
  },
};
